"use strict";
/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
Object.defineProperty(exports, "__esModule", { value: true });
exports.TipType = exports.OrderStatus = exports.OptionGroupWidget = exports.IdentityProvider = void 0;
//==============================================================
// START Enums and Input Objects
//==============================================================
var IdentityProvider;
(function (IdentityProvider) {
    IdentityProvider["APPLE"] = "APPLE";
    IdentityProvider["AUTH0"] = "AUTH0";
    IdentityProvider["FACEBOOK"] = "FACEBOOK";
    IdentityProvider["SMS"] = "SMS";
})(IdentityProvider = exports.IdentityProvider || (exports.IdentityProvider = {}));
var OptionGroupWidget;
(function (OptionGroupWidget) {
    OptionGroupWidget["CAROUSEL"] = "CAROUSEL";
    OptionGroupWidget["RADIO"] = "RADIO";
})(OptionGroupWidget = exports.OptionGroupWidget || (exports.OptionGroupWidget = {}));
var OrderStatus;
(function (OrderStatus) {
    OrderStatus["AwaitingPickup"] = "AwaitingPickup";
    OrderStatus["CancelledPreorder"] = "CancelledPreorder";
    OrderStatus["Created"] = "Created";
    OrderStatus["Failed"] = "Failed";
    OrderStatus["Fulfilled"] = "Fulfilled";
    OrderStatus["Paid"] = "Paid";
    OrderStatus["PartialRefund"] = "PartialRefund";
    OrderStatus["Preorder"] = "Preorder";
    OrderStatus["Refunded"] = "Refunded";
    OrderStatus["Rejected"] = "Rejected";
    OrderStatus["Scheduled"] = "Scheduled";
})(OrderStatus = exports.OrderStatus || (exports.OrderStatus = {}));
var TipType;
(function (TipType) {
    TipType["Amount"] = "Amount";
    TipType["None"] = "None";
    TipType["Percent"] = "Percent";
})(TipType = exports.TipType || (exports.TipType = {}));
//==============================================================
// END Enums and Input Objects
//==============================================================
//# sourceMappingURL=globalTypes.js.map